import nyNetwork from "@/api/nyBaseNetwork";
import DZSearchCourtship from "@/views/审核管理/model/search/DZSearchCourtship";
import DZModelAddress from "@/views/审核管理/model/DZModelAddress";
import DZModelContacts from "@/views/审核管理/model/DZModelContacts";
import DZModelCourtshipBase from "@/views/审核管理/model/DZModelCourtshipBase";
import DZModelListCourtship from "@/views/审核管理/model/list/DZModelListCourtship";

class DZServiceCourtship{

    m_search = new DZSearchCourtship(10);

    /** 招商审核列表 **/
    list_courtship : Array<DZModelListCourtship> = [];

    /** 招商基本信息 **/
    base = new DZModelCourtshipBase();
    /** 位置 **/
    address = new DZModelAddress();
    /** 联系人 **/
    contact = new DZModelContacts();

    sum = {
        all:'',
        listed:'',
        delisted:'',
        unaudited:''
    }

    net_page_courtship(){
        let arr = this.m_search.countyArr
        if(arr.length != 0){
            this.m_search.level = String(arr.length)
            this.m_search.county = arr[arr.length-1]
        }
        nyNetwork.net("招商信息审核列表",this.m_search, data => {
            this.list_courtship = data.list
            this.m_search.total = data.total
        })
        nyNetwork.net("招商信息审核列表统计",this.m_search, res => {
            if(res){
                this.sum.all = res.all
                this.sum.listed = res.listed
                this.sum.delisted = res.delisted
                this.sum.unaudited = res.unaudited
            }
        })
    }

    net_courtship_info(id){
        nyNetwork.net("招商信息详情",{id:id}, data => {
            this.base = data.baseInfo
            this.address = data.addressInfo
            this.contact = data.contactsInfo
        })
    }

    net_edit_courtship_base(m_base){
        nyNetwork.net("修改招商基本信息",m_base, data => {

        })
    }

    net_edit_address(m_address){
        nyNetwork.net("修改招商位置",m_address, data => {

        })
    }

    net_edit_contact(m){
        nyNetwork.net("修改招商联系人",m, data => {
            //success()
        })
    }

    net_courtship_pass(id,success: () => void){
        nyNetwork.net("招商审核通过",{id:id}, data => {
            success()
        })
    }

    net_courtship_refuse(id,success: () => void){
        nyNetwork.net("招商审核拒绝",{id:id}, data => {
            success()
        })
    }

    net_courtship_operate(id,success: () => void){
        nyNetwork.net("招商暂停/继续发布",{id:id}, data => {
            success()
        })
    }

    net_batch_deList(idList,success: () => void){
        nyNetwork.net("招商批量下架",[...idList], data => {
            success()
        })
    }

}
export default DZServiceCourtship;
